<template>
    <v-progress-circular
        :model-value="percent"
        :size="100"
        :width="15"
        :color="color">
    {{ value }}/{{ max }}
    </v-progress-circular>
</template>

<script>
export default  {
    name: 'CircularProgressComponent',

    props:{
        value: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: false,
            default: 'primary', //primary, secondary, warning, error, success
        }
    },

    created(){
        console.log(`CircularProgressComponent > created > color = ${this.color}`)
    },

    computed:{
        percent(){
            return Math.floor(this.value / this.max * 100)
        }
    }
}
</script>